import { Box, FormControl, IconButton, MenuItem, Select, TextField, Tooltip } from '@mui/material'
import { ActivityLevel, WasteStatus, WasteType } from '@services/dtos'
import { ActivityLevelLabels, WasteStatusLabels, WasteTypeLabels } from '@utils/constants'
import { useAppDispatch } from '@hooks/reduxHooks'
import { WasteTableTabs } from './WasteTableTabs'
import { useSelector } from '@state/store'
import { getWasteContainers, setWasteContainerFilters } from '@state/reducers/wasteContainerReducer'
import { Sync } from '@mui/icons-material'

type Props = {
  showTabs?: boolean
}

export function WasteContainersToolbar({ showTabs = false }: Props) {
  const dispatch = useAppDispatch()
  const { filters } = useSelector(({ wasteContainer }) => ({ filters: wasteContainer.filters }))

  return (
    <Box className="flex items-center gap-2 flex-wrap">
      {showTabs && <WasteTableTabs />}
      <Tooltip title="Actualiser" arrow>
        <IconButton onClick={() => dispatch(getWasteContainers())}>
          <Sync />
        </IconButton>
      </Tooltip>
      <TextField
        size="small"
        label="N° conteneur"
        type="number"
        value={filters.no ?? ''}
        onChange={(e) => dispatch(setWasteContainerFilters({ no: e.target.value ? Number(e.target.value) : undefined, page: 0 }))}
        sx={{ width: 135 }}
        inputProps={{ min: 1 }}
      />
      <FormControl size="small" sx={{ minWidth: 110 }}>
        <Select
          displayEmpty
          value={filters.status || ''}
          onChange={(e) => {
            const value = e.target.value === '' ? undefined : (e.target.value as WasteStatus)
            dispatch(setWasteContainerFilters({ status: value }))
          }}
          renderValue={(value) => value ? WasteStatusLabels[value] : 'Statut'}
        >
          <MenuItem value="">Tous</MenuItem>
          {Object.values(WasteStatus).map((s) => (
            <MenuItem key={s} value={s}>{WasteStatusLabels[s]}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 145 }}>
        <Select
          displayEmpty
          value={filters.type || ''}
          onChange={(e) => {
            const value = e.target.value === '' ? undefined : (e.target.value as WasteType)
            dispatch(setWasteContainerFilters({ type: value }))
          }}
          renderValue={(value) => value ? WasteTypeLabels[value] : 'Type'}
        >
          <MenuItem value="">Tous</MenuItem>
          {Object.values(WasteType).map((t) => (
            <MenuItem key={t} value={t}>{WasteTypeLabels[t]}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 155 }}>
        <Select
          displayEmpty
          value={filters.activityLevel || ''}
          onChange={(e) => {
            const value = e.target.value === '' ? undefined : (e.target.value as ActivityLevel)
            dispatch(setWasteContainerFilters({ activityLevel: value }))
          }}
          renderValue={(value) => value ? ActivityLevelLabels[value] : 'Niveau d\'activité'}
        >
          <MenuItem value="">Tous</MenuItem>
          {Object.values(ActivityLevel).map((a) => (
            <MenuItem key={a} value={a}>{ActivityLevelLabels[a]}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
